import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const EkgDivider = () => (
  <div className="w-full overflow-hidden py-6" aria-hidden="true">
    <svg viewBox="0 0 1200 60" className="w-full h-12" fill="none" preserveAspectRatio="none">
      <path
        className="ekg-path"
        d="M0 30 H300 L330 30 L345 8 L365 52 L380 18 L395 30 H600 L630 30 L645 8 L665 52 L680 18 L695 30 H900 L930 30 L945 8 L965 52 L980 18 L995 30 H1200"
        stroke="#FF1493"
        strokeWidth="1.5"
      />
    </svg>
  </div>
);

export const FlightPathDivider = () => (
  <div className="w-full overflow-hidden py-4" aria-hidden="true">
    <svg viewBox="0 0 1200 40" className="w-full h-8" fill="none" preserveAspectRatio="none">
      <path d="M0 20 C 300 -10, 900 50, 1200 20" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" strokeDasharray="2 10" strokeLinecap="round" />
      <circle cx="1180" cy="21" r="4" fill="#FF1493" />
      <circle cx="20" cy="19" r="4" fill="rgba(255,255,255,0.4)" />
    </svg>
  </div>
);
